import React from "react"
import { cn } from "design_system/libs"
import TopicBadge from "@love-irish/resource-topic-badge"

export interface Topic {
  id?: string
  slug: string
  name?: string
  color?: string
  path?: string
}

export interface ItemTopic {
  id: string
  source?: string
  topic: Topic
}

export interface TopicListProps {
  /** Array of item topics (with nested topic object) */
  itemTopics?: ItemTopic[]
  /** Additional CSS classes for the container */
  className?: string
  /** Additional CSS classes for each badge */
  badgeClassName?: string
}

export const TopicList: React.FC<TopicListProps> = ({
  itemTopics,
  className,
  badgeClassName = "mr-2 mb-2",
}) => {
  if (!itemTopics?.length) return null

  return (
    <div className={cn("mt-6", className)}>
      {itemTopics.map((itemTopic) => (
        <TopicBadge
          key={itemTopic.id}
          topic={itemTopic.topic}
          className={badgeClassName}
        />
      ))}
    </div>
  )
}

export default TopicList
